import React from "react";
import { Typography, Stack, Divider } from "@mui/material";
import SideNavLink from "components/base/SideNavLink";

export default function SideMenu() {
  return (
    <React.Fragment>
      <Stack direction="column" gap={1} sx={{ ml: 3, pt: 2 }}>
        <Typography variant="h6" color="#5c6d7e" fontStyle="italic" mt={1.3}>
          Misinformation Toolkit
        </Typography>
        <SideNavLink to="/tools/domain-checker">Domain Checker</SideNavLink>
        <SideNavLink end={false} to="/tools/false-claim-fingerprints">
          False Claim Fingerprints
        </SideNavLink>
        <SideNavLink to="/tools/dubious-sources-search/">
          Dubious Sources Search
        </SideNavLink>
      </Stack>
    </React.Fragment>
  );
}
